import type {ReactElement} from 'react';
import React from 'react';
import {ItemHeaderTab} from '@Components/poster-editor/components/poster-editing-side-panel/poster-editing-side-panel.types';
import {ContextualMenuTabsHeader} from '@Components/contextual-menu/components/contextual-menu-tabs-header';
import {ContextualMenuHeader} from '@Components/contextual-menu/components/contextual-menu-header';

interface DefaultEditingOptionsHeaderProps {
  currentItemHeaderTab: ItemHeaderTab;

  onChangeSelectedHeaderItemTab(id: ItemHeaderTab): void;
}

export function DefaultEditingOptionsHeader({...props}: DefaultEditingOptionsHeaderProps): ReactElement<any> | null {
  const getHeaderContent = (): ReactElement<any> => {
    return (
      <ContextualMenuTabsHeader
        id="poster-editing-item-tab-header"
        tabData={[
          {
            id: ItemHeaderTab.EDIT,
            text: window.i18next.t('pmwjs_edit_item'),
          },
          {
            id: ItemHeaderTab.POSITION,
            text: window.i18next.t('pmwjs_position'),
          },
        ]}
        selectedTabId={props.currentItemHeaderTab}
        onClick={(id: ItemHeaderTab): void => {
          props.onChangeSelectedHeaderItemTab(id);
        }}
      />
    );
  };

  const getHeader = (): ReactElement<any> => {
    return <ContextualMenuHeader id="default-contextual-menu-header">{getHeaderContent()}</ContextualMenuHeader>;
  };

  return getHeader();
}
